import dom from '../../utils/dom';
import DomEffects from '../../utils/DomEffects';

class PaymentPlanSelectionOption {
  constructor($el, onRadioChange) {
    this.$radio = dom.findFrom($el, '.tn-payment-plan-selection__billing-schedule-input');
    this.$details = dom.findFrom($el, '.tn-payment-plan-selection__billing-schedule-details');

    this.id = this.$radio.value;

    this.$radio.addEventListener('change', () => { onRadioChange(this); });
  }

  getId() {
    return this.id;
  }

  hideDetails() {
    if (!this.$details) {
      return;
    }

    DomEffects.collapse(this.$details);
  }

  showDetails() {
    if (!this.$details) {
      return;
    }

    DomEffects.expand(this.$details);
  }
}

export default PaymentPlanSelectionOption;
